/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { PaymentContainer } from './container';
import { useNavigate } from 'react-router-dom';

export const PaymentPage = ({ navigation }: { navigation: any }) => {
  const history = useNavigate();
  const onSuccess = () => {
    history('/payment-success');
  };
  const onFailure = () => {
    history('payment-failure');
  };
  return <PaymentContainer onSuccess={onSuccess} onFailure={onFailure} />;
};
